import { render, staticRenderFns } from "./bookManage.vue?vue&type=template&id=b0b6fa04"
import script from "./bookManage.vue?vue&type=script&lang=js"
export * from "./bookManage.vue?vue&type=script&lang=js"
import style0 from "./bookManage.vue?vue&type=style&index=0&id=b0b6fa04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports